import BaseModel from './base/baseModel';

export default class DevolucaoItemModel extends BaseModel {
    devolucaoId: number = null;
    produtoLoteId: number = null;
    unidadeMedidaId: number = null;
    produtoLoteModel: number = null;
    quantidadeDevolvida: number = null;
    valorUnitario: number = null;
}